import { NavigationPath } from "./navigation-path";
import Screens from "@/screens";
import { Route } from "@/router/router-types";

export const publicRoutes: Route[] = [
  {
    path: NavigationPath.landing,
    element: <Screens.DashBoardView />,
  },
];
